import { BTime } from './time';
import { pluginFactory } from '../../utils/plugins';
var TimePlugin = /*#__PURE__*/pluginFactory({
  components: {
    BTime: BTime
  }
});
export { TimePlugin, BTime };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/time/index.js
// module id = 280
// module chunks = 0